import React from "react";
import { Container } from "@jsluna/grid";

const PageFormat = ({ children }) => {
  return (
    <Container
      soft
      size="xs"
      className="ln-u-margin-bottom*4"
      style={{ maxWidth: "36rem" }}
    >
      {children}
    </Container>
  );
};

export default PageFormat;
